import { Spinner } from "components/atoms/Icon";
import "./index.scss";

interface IProps {
  theme: "light" | "dark";
  content: string;
  isLoading?: boolean;
}

export const PersonalizedBanner = ({
  theme,
  content,
  isLoading = false,
}: IProps) => {
  if (!content) {
    return null;
  }

  return (
    <div className="personalized-banner-wrapper">
      {isLoading ? (
        <div className="personalized-banner-loading">
          <Spinner theme={theme} />
        </div>
      ) : (
        <div
          className={`personalized-banner-content ${
            theme === "dark"
              ? "personalized-banner-content-dark"
              : "personalized-banner-content-light"
          }`}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      )}
    </div>
  );
};
